import { FC } from 'react';

import Image from './image.svg';

export const UsdcLogo: FC = () => <img src={Image} alt="usdc" />;
